var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"item",staticClass:"timeline-item",style:({marginBottom:_vm.bottomMargin+'px'})},[_c('div',{ref:"title",staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-line-container"},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"line"}),_c('div',{staticClass:"line short"})])
}]

export { render, staticRenderFns }